import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  Nav, 
  Offcanvas, 
  Collapse,
  Button
} from 'react-bootstrap';
import {
  LayoutDashboard,
  Package,
  ListOrdered,
  Bell,
  Settings,
  LogOut,
  ChevronDown,
  ChevronRight,
  Utensils,
  Droplet,
  Pill
} from 'lucide-react';
import '../../assets/css/receiverdashboard/ReceiverSideBar.css';

const ReceiverSideBar = () => {
  const [show, setShow] = useState(false);
  const [donationOpen, setDonationOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const toggleDonation = () => setDonationOpen(!donationOpen);

  const isActive = (path) => location.pathname === path;
   const handleLogout = () => {
    localStorage.clear(); // sab kuch clear
    navigate("/receiver"); // login page py redirect
  };

  const menuItems = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      path: '/receiver/dashboard',
      icon: <LayoutDashboard size={20} />
    },
    {
      id: 'donation-listing',
      title: 'Donation Listing',
      icon: <Package size={20} />,
      hasDropdown: true,
      subItems: [
        {
          id: 'food',
          title: 'Food Donation',
          path: '/receiver/food-donation',
          icon: <Utensils size={18} />
        },
        {
          id: 'blood',
          title: 'Blood Donation',
          path: '/receiver/blood-donation',
          icon: <Droplet size={18} />
        },
        {
          id: 'medicine',
          title: 'Medicine Donation',
          path: '/receiver/medicine-donation',
          icon: <Pill size={18} />
        }
      ]
    },
    {
      id: 'my-listing',
      title: 'My Listing',
      path: '/receiver/mylistings',
      icon: <ListOrdered size={20} />
    },
   // {
    // id: 'help-support',
    // title: 'Help & Support',
    // path: '/receiver/help-support',
    // icon: <ListOrdered size={20} />
    // },
    {
      id: 'notification',
      title: 'Notification',
      path: '/receiver/notification',
      icon: <Bell size={20} />,
      badge: 5
    },
    {
      id: 'settings',
      title: 'Settings',
      path: '/receiver/settings',
      icon: <Settings size={20} />
    }
  ];


  const SidebarContent = ({ isMobile = false }) => (
    <div className="sidebar-content-wrapper">
      {/* Sidebar Header */}
      <div className="sidebar-header-custom">
        <div className="logo-section">
          <div className="logo-circle">
            <Droplet className="logo-icon" size={28} />
          </div>
          <div className="logo-text-section">
            <h5 className="logo-title">SDMS</h5>
            <p className="logo-subtitle">Receiver Portal</p>
          </div>
        </div>
      </div>

      {/* User Profile Section */}
      <div className="user-profile-section">
        <div className="user-avatar-container">
          <div className="user-avatar-circle">FA</div>
          <div className="user-status-indicator"></div>
        </div>
        <div className="user-info-section">
          <h6 className="user-name">Fattima Ali</h6>
          <p className="user-role">Receiver Account</p>
        </div>
      </div>

      {/* Navigation Menu */}
      <Nav className="flex-column sidebar-nav-custom">
        {menuItems.map((item) => (
          <div key={item.id} className="nav-item-wrapper">
            {item.hasDropdown ? (
              <>
                <div
                  className={`nav-link-custom ${donationOpen ? 'active' : ''}`}
                  onClick={toggleDonation}
                >
                  <div className="nav-link-content">
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-text">{item.title}</span>
                  </div>
                  <span className="dropdown-indicator">
                    {donationOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                  </span>
                </div>

                <Collapse in={donationOpen}>
                  <div className="dropdown-menu-custom">
                    {item.subItems.map((subItem) => (
                      <Link
                        key={subItem.id}
                        to={subItem.path}
                        className={`dropdown-item-custom ${isActive(subItem.path) ? 'active' : ''}`}
                        onClick={isMobile ? handleClose : undefined}
                      >
                        <span className="dropdown-icon">{subItem.icon}</span>
                        <span className="dropdown-text">{subItem.title}</span>
                      </Link>
                    ))}
                  </div>
                </Collapse>
              </>
            ) : (
              <Link
                to={item.path}
                className={`nav-link-custom ${isActive(item.path) ? 'active' : ''}`}
                onClick={isMobile ? handleClose : undefined}
              >
                <div className="nav-link-content">
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-text">{item.title}</span>
                </div>
                {item.badge && (
                  <span className="nav-badge">{item.badge}</span>
                )}
              </Link>
            )}
          </div>
        ))}
      </Nav>

      {/* Logout Button */}
      <div className="sidebar-footer-custom">
        <Button onClick ={handleLogout} className="logout-btn-custom">
          <LogOut size={20} />
          <span>Logout</span>
        </Button>
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="sidebar-desktop">
        <SidebarContent />
      </div>

      {/* Mobile Offcanvas Sidebar */}
      <Offcanvas 
        show={show} 
        onHide={handleClose} 
        className="sidebar-offcanvas"
        placement="start"
      >
        <Offcanvas.Header closeButton className="offcanvas-header-custom">
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="offcanvas-body-custom">
          <SidebarContent isMobile={true} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ReceiverSideBar;